import { isMobile } from '@common/utils';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';

interface HideOnScrollProps {
  children: React.ReactNode;
  className: string;
  web?: boolean;
  mobile?: boolean;
  top: number;
}

function useScrollDirection() {
  const [scrollDirection, setScrollDirection] = useState(null);

  useEffect(() => {
    let lastScrollY = window.pageYOffset;

    const updateScrollDirection = () => {
      const scrollY = window.pageYOffset;
      const direction = scrollY > lastScrollY ? 'down' : 'up';
      if (direction !== scrollDirection && (scrollY - lastScrollY > 10 || scrollY - lastScrollY < -10)) {
        setScrollDirection(direction);
      }
      lastScrollY = scrollY > 0 ? scrollY : 0;
    };
    window.addEventListener('scroll', updateScrollDirection); // add event listener
    return () => {
      window.removeEventListener('scroll', updateScrollDirection); // clean up
    };
  }, [scrollDirection]);

  return scrollDirection;
}

const HideOnScroll: React.FC<HideOnScrollProps> = ({ children, className, top, mobile = false, web = false }) => {
  const scrollDirection = useScrollDirection();
  let topValue: string;

  //Calculating Value based on scroll direction
  const value = scrollDirection === 'down' ? `-100px` : `${top}px`;

  //Mobile Validation
  if (isMobile()) mobile ? (topValue = value) : (topValue = `${top}px`);

  //Browser Validation
  if (!isMobile()) web ? (topValue = value) : (topValue = `${top}px`);

  return (
    <>
      <div style={{ top: topValue }} className={classNames(`sticky duration-500 transition-top`, className)}>
        {children}
      </div>
    </>
  );
};

export default HideOnScroll;

//For Transition : add <top: 'top'> to the transitionProperty of respective Theme-tailwind config file
